import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { useSelector } from 'react-redux';
import PipeProvider from '../../Services/Providers/PipeProvider';

import PropTypes from 'prop-types';

import {
  Col,
  Row,
  VertButton,
  VertCheckbox,
  VertIcon,
  VertInput,
  VertSearch,
  VertTypography,
} from '@vertem-core/vertice-ds';

import FilterWrapper from './FilterWrapper';

import { AddIndexInSearchHash, RemoveIndexInSearchHash } from '../../Utils/createSearchHash';

const MultipleOptionsFilter = ({
  categories, maxItemsToShow=5, value, onChange,
}) => {
  const [visibleItems, setVisibleItems] = useState(maxItemsToShow);
  const showMoreItems = () => {
    setVisibleItems(visibleItems + maxItemsToShow);
  };

  const showLessItems = () => {
    setVisibleItems(maxItemsToShow);
  };

  const optionsCategories = categories
    .slice(0, visibleItems)
    .map((item) => {
      return (
        <VertCheckbox
          onChange={({ target: { value: v, checked } }) => {
            if (checked) {
              if (onChange) onChange(v, true);
            } else if (onChange) {
              onChange(v, false);
            }
          }}
          checked={(value && value.filter(i => `${ i?.value }` === `${ item?.value }`)?.length > 0)}
          size="small"
          block
          value={item.value}
          key={item.value}
          aria-label={item.ariaLabel || item.value}
        >
          {item.label}
        </VertCheckbox>
      );
    });
  return (
    <div>
      {optionsCategories}
      {categories.length > visibleItems ? (
        <div>
          {
            (visibleItems <= maxItemsToShow || visibleItems < categories.length) && (
              <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showMoreItems}>
                Mostrar mais
              </VertButton>
            )
          }
          {(visibleItems > maxItemsToShow && visibleItems > categories.length) && (
            <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showLessItems}>
              Mostrar menos
            </VertButton>
          )}
        </div>
      ) : null}
    </div>
  );
};

MultipleOptionsFilter.propTypes = {
  categories: PropTypes.array.isRequired,
  maxItemsToShow: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
};


const OptionsFilter = ({
  categories, maxItemsToShow=5, value, onChange,
}) => {
  const [visibleItems, setVisibleItems] = useState(maxItemsToShow);

  const showMoreItems = () => {
    setVisibleItems(visibleItems + maxItemsToShow);
  };

  const showLessItems = () => {
    setVisibleItems(maxItemsToShow);
  };

  const optionsCategories = categories
    .slice(0, visibleItems)
    .map((item) => {
      return (
        <VertCheckbox
          onChange={({ target: { value: v, checked } }) => {
            if (checked) {
              if (onChange) onChange(v);
            } else if (onChange) {
              onChange(null);
            }
          }}
          checked={(value && value === item.value)}
          size="small"
          block
          value={item.value}
          key={item.value}
          aria-label={item.ariaLabel || item.value}
        >
          {item.label}
        </VertCheckbox>
      );
    });
  return (
    <div>
      {optionsCategories}
      {categories.length > visibleItems ? (
        <div>
          {
              visibleItems <= maxItemsToShow && (
                <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showMoreItems}>
                  Mostrar mais
                </VertButton>
              )
          }
          {visibleItems > maxItemsToShow && (
          <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showLessItems}>
            Mostrar menos
          </VertButton>
          )}
        </div>
      ) : null}
    </div>
  );
};

OptionsFilter.propTypes = {
  categories: PropTypes.array.isRequired,
  maxItemsToShow: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

const OptionsStores = ({
  stores, maxItemsToShow=8, value, onChange,
}) => {
  const Stores = useSelector(({ Stores: data }) => data);
  const [visibleItems, setVisibleItems] = useState(maxItemsToShow);

  const GetImageOfStoresById = useCallback((id) => {
    if (!Stores || !Stores.ecommerce || !Stores.ecommerce.length) return '';
    const filterStore = (Stores.ecommerce || []).filter(({ supplierId }) => supplierId === id);
    return (filterStore[0]) ? filterStore[0].imageUrl : `https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png`;
  }, [Stores]);

  const showMoreItems = () => {
    const showItems = visibleItems + maxItemsToShow;
    setVisibleItems(showItems);
  };

  const showLessItems = () => {
    setVisibleItems(maxItemsToShow);
  };

  return (
    <>
      { stores
        .slice(0, visibleItems)
        .map((item) => {
          return (
            <Col span={24} verticalSpacing="extra-small">
              <VertCheckbox
                {...item}
                brand={GetImageOfStoresById(item.id)}
                className="filter-store"
                checked={value && value.indexOf(item.id) >= 0}
                onClick={() => {
                  if (value.indexOf(item.id) < 0) {
                    onChange(item.id, true);
                  } else {
                    onChange(item.id, false);
                  }
                }}
              >
                {item.name}
              </VertCheckbox>
            </Col>
          );
        }) }
      {stores.length > visibleItems ? (
        <div>
          {
            visibleItems <= maxItemsToShow && (
            <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showMoreItems}>
              Mostrar mais
            </VertButton>
            )
        }
          {visibleItems > maxItemsToShow && (
          <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showLessItems}>
            Mostrar menos
          </VertButton>
          )}
        </div>
      ) : null}
    </>
  );
};

OptionsStores.propTypes = {
  stores: PropTypes.array.isRequired,
  maxItemsToShow: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};


const PriceFilter = ({
  min, max, setFilterPrice, addFilter, clearFilter,
}) => {
  return (
    <FilterWrapper title="Valor do resgate">
      <Row gutter={16}>
        <Col span={12}>
          <VertInput
            value={min || 0}
            onChange={(e) => {
              const { value } = e.target;
              setFilterPrice(value, max);
            }}
            label="De"
          />
        </Col>
        <Col span={12}>
          <VertInput
            value={max || 0}
            onChange={(e) => {
              const { value } = e.target;
              setFilterPrice(min, value);
            }}
            label="Até"
          />
        </Col>
      </Row>
      <Row gutter={16} className="margin-top-small">
        <Col span={12}>
          <VertButton
            className="w-100"
            type="detached"
            spacing="small"
            onClick={() => {
              addFilter();
            }}
          >
            Aplicar
          </VertButton>
        </Col>
        <Col span={12}>
          <VertButton
            icon={<VertIcon isVertice iconName="Trash" size="extra-small" className="margin-right-extra-small  vert-filters-clean-icon" />}
            type="link"
            className="color-detached w-100  vert-filters-clean"
            spacing="small"
            onClick={() => clearFilter()}
          >
            Limpar
          </VertButton>
        </Col>
      </Row>
    </FilterWrapper>
  );
};

PriceFilter.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  setFilterPrice: PropTypes.func,
  addFilter: PropTypes.func,
  clearFilter: PropTypes.func,
};

const SearchFilter = ({
  className, filters, filterParams, onSubmit, clearFilters, hideStores, identifier, type, hideSearchTerm
}) => {
  const [term, setTerm] = useState(null);
  const SearchData = useSelector(({ Search: data }) => data);
  const ShowcaseData = useSelector(({ Showcase: data }) => data);
  const [ Search, setSearch ] = useState({})
  const [minprice, setMinprice] = useState(null);
  const [maxprice, setMaxprice] = useState(null);
  const [subcategories, setSubcategory] = useState(null);
  const [vendor, setVendor] = useState([]);
  const [brands, setBrands] = useState([]);
  const [features, setFeatures] = useState([]);
  const [showCategoryFilter, setShowCategoryFilter] = useState(true);
  const [filteredCategory, setFilteredCategory] = useState();

  const EMPTY_STRING = "e30=";

  const location = useLocation();

  const isPageFilteredByCategory = () => {
    return location.pathname.startsWith("/category/");
  }

  const clearFilter = (filter) => {
      const filterParamsHash = filterParams || 'e30=';

      const newHash = RemoveIndexInSearchHash(filterParamsHash, filter);
      if (newHash === 'e30=') {
        onSubmit(false);
        return;
      }
      if (onSubmit) onSubmit(newHash);
  };

  const ShowcaseFilter = useCallback(() => {
    setSearch({ data: ShowcaseData[type][identifier]});
  }, [ ShowcaseData, identifier, type  ])

  useEffect(() => {
    if (!identifier) {
      setSearch(SearchData);
    } else if ( identifier ) {
      ShowcaseFilter()
    }
  }, [ SearchData, ShowcaseData, identifier, type ])

  useEffect(() => {
    if (filters) {
      if (filters.term !== undefined && filters.term !== null) setTerm(filters.term);
      if (filters.minprice !== undefined && filters.minprice !== null) {
        setMinprice(filters.minprice);
      }
      if (filters.maxprice !== undefined && filters.maxprice !== null) {
        setMaxprice(filters.maxprice);
      }

      if (filters.categories) {
        const categoryId = parseInt(filters.categories);

        if (isPageFilteredByCategory()) setShowCategoryFilter(false);

        setFilteredCategory(categoryId);
      }

      if (filters.subcategories !== undefined && filters.subcategories !== null) {
        setSubcategory(parseInt(`${ filters.subcategories }`));
      }
      if (filters.vendors !== undefined && filters.vendors !== null) {
        setVendor(filters.vendors.split(',').map((e) => parseInt(`${ e }`)));
      }
      if (filters.brands !== undefined && filters.brands !== null) {
        setBrands(filters.brands.split(',').map((e) => parseInt(`${ e }`)));
      }

      const featuresFilterValue = {};
      const featuresFilterType = {};
      Object.keys(filters).forEach((f) => {
        if (/^(Features)+(\[)+([0-9])+(\])+(\.)+(Value)$/.test(f)) {
          featuresFilterValue[f] = filters[f];
        } else if (/^(Features)+(\[)+([0-9])+(\])+(\.)+(Type)$/.test(f)) {
          featuresFilterType[f] = filters[f];
        }
      });

      if (Object.keys(featuresFilterValue).length) {
        const featuresList = [];
        Object.keys(featuresFilterValue).forEach((_, ind) => {
          featuresList.push({
            type: featuresFilterType[`Features[${ind}].Type`],
            value: featuresFilterValue[`Features[${ind}].Value`],
          });
        });
        setFeatures(featuresList);
      }
    }
  }, [filters]);

  const extractCategories = (searchCategoriesResult) => {
    return searchCategoriesResult.map(({ name, id }) => ({ label: name, value: id }));
  }

  const onCategoryFilterChange = (categoryId) => {
    const hashedFilterParams = filterParams || EMPTY_STRING;

    if (!categoryId) {
      setFilteredCategory(null);

      const newSearchHash = RemoveIndexInSearchHash(hashedFilterParams, ["categories"]);
      onSubmit(newSearchHash);

      return;
    }

    setFilteredCategory(categoryId);

    const updatedFilter = {
      categories: categoryId,
    };

    const newSearchHash = AddIndexInSearchHash(hashedFilterParams, updatedFilter);
    onSubmit(newSearchHash);
  }

  return (
    <Col className="col-auto">
      <div className={`vert-search-sidebar vert-sidebar vert-bordered ${className || ''}`}>
        <Row justify="center" align="middle" className="vert-box-filter vert-box-filter-title  not-bordered margin-bottom-extra-small" gutter={8}>
          <Col flex="auto" className="vert-box-filter vert-box-filter-title-label">
            <VertTypography.Title level={2} className="margin-bottom-none">Filtros</VertTypography.Title>
          </Col>
          <Col flex="none" className="vert-box-filter vert-box-filter-title-button">
            <VertButton
              icon={<VertIcon isVertice iconName="Trash" size="extra-small" className="margin-right-extra-small vert-filters-clean-icon" />}
              type="link"
              spacing="none"
              className="color-detached vert-filters-clean"
              size="small"
              onClick={() => { clearFilters(); }}
            >
              Limpar Filtros
            </VertButton>
          </Col>
        </Row>
        {(() => {
          if (hideSearchTerm) return null;
          return (
              <Row
                  justify="center"
                  align="middle"
                  className="vert-box-filter vert-box-filter vert-box-filter-title margin-top-small padding-bottom-small"
                  gutter={8}
              >
                <Col span={24}>
                  <VertSearch
                      value={term}
                      placeholder={term || 'O que você está buscando?'}
                      onButtonHandler={(event) => {
                        const { value } = event.currentTarget;
                        setTerm(value);

                        let newHash;
                        const filterObj = {};
                        let filterParamsHash = filterParams || 'e30=';
                        if (value) {
                          filterObj.term = value;
                        } else {
                          filterParamsHash = RemoveIndexInSearchHash(filterParamsHash, ['term']);
                        }

                        if (filterParamsHash) {
                          newHash = AddIndexInSearchHash(filterParamsHash, filterObj);
                        } else {
                          newHash = AddIndexInSearchHash('e30=', filterObj);
                        }

                        if (newHash === 'e30=') {
                          onSubmit(false);
                          return;
                        }
                        if (onSubmit) onSubmit(newHash);
                      }}
                  />
                </Col>
              </Row>
          )
        })()}
        <PriceFilter
          max={maxprice || 0}
          min={minprice || 0}
          setFilterPrice={(min, max) => {
            if (min !== minprice) setMinprice(min);
            if (max !== maxprice) setMaxprice(max);
          }}
          addFilter={() => {
            let newHash;
            const filterObj = {};
            let filterParamsHash = filterParams || 'e30=';

            filterParamsHash = RemoveIndexInSearchHash(filterParamsHash, ['minprice', 'maxprice']);
            if (minprice) filterObj.minprice = minprice;
            if (maxprice) filterObj.maxprice = maxprice;

            if (filterParamsHash) {
              newHash = AddIndexInSearchHash(filterParamsHash, filterObj);
            } else {
              newHash = AddIndexInSearchHash('e30=', filterObj);
            }
            if (newHash === 'e30=') {
              onSubmit(false);
              return;
            }
            if (onSubmit) onSubmit(newHash);
          }}
          clearFilter={() => {
            setMinprice(null);
            setMaxprice(null);
            return clearFilter(['minprice', 'maxprice']);
          }}
        />

        {
          (showCategoryFilter && Search?.data?.categories) && (
            <FilterWrapper title="Categorias">
              <OptionsFilter 
                categories={extractCategories(Search.data.categories)}
                maxItemsToShow="5"
                value={filteredCategory}
                onChange={onCategoryFilterChange}
              />
            </FilterWrapper>
          )
        }

        {(() => {
          if (
            !Search
            || !Search.data
            || !Search.data.subcategories
            || !Search.data.subcategories.length
          ) return null;
          return (
            <FilterWrapper title="Subcategorias">
              <OptionsFilter
                categories={Search.data.subcategories.map(({
                  id,
                  name,
                }) => ({ label: name, value: id }))}
                maxItemsToShow="5"
                value={subcategories}
                onChange={(e) => {
                  setSubcategory(e);
                  let newHash;
                  const filterObj = {};
                  let filterParamsHash = filterParams || 'e30=';
                  if (e) {
                    filterObj.subcategories = e;
                  } else {
                    filterParamsHash = RemoveIndexInSearchHash(filterParamsHash, ['subcategories']);
                  }

                  if (filterParamsHash) {
                    newHash = AddIndexInSearchHash(filterParamsHash, filterObj);
                  } else {
                    newHash = AddIndexInSearchHash('e30=', filterObj);
                  }

                  if (newHash === 'e30=') {
                    onSubmit(false);
                    return;
                  }
                  if (onSubmit) onSubmit(newHash);
                }}
              />
            </FilterWrapper>
          );
        })()}

        {(() => {
          if (
            !Search
            || !Search.data
            || !Search.data.vendors
            || !Search.data.vendors.length
            || hideStores
          ) return null;
          return (
            <PipeProvider
              apiSymbols={['FETCH_STORES']}
            >
              <FilterWrapper title="Lojas">
                <Row gutter={8}>
                <OptionsStores
                    stores={Search.data.vendors.map(({ name, id }) => ({
                      name,
                      id: parseInt(`${ id }`),
                    }))}
                    maxItemsToShow="8"
                    value={vendor}
                    onChange={(newVendor, add) => {
                      let newVendors = [...vendor];
                      if (add) {
                        newVendors.push(newVendor);
                      } else {
                        newVendors = newVendors.filter((e) => e !== newVendor);
                      }

                      setVendor(newVendors);
                      let newHash;
                      const filterObj = {};
                      let filterParamsHash = filterParams || 'e30=';
                      if (!newVendors.length) {
                        filterParamsHash = RemoveIndexInSearchHash(filterParamsHash, ['vendors']);
                      } else {
                        filterObj.vendors = newVendors.join(',');
                      }

                      if (filterParamsHash) {
                        newHash = AddIndexInSearchHash(filterParamsHash, filterObj);
                      } else {
                        newHash = AddIndexInSearchHash('e30=', filterObj);
                      }

                      if (newHash === 'e30=') {
                        onSubmit(false);
                        return;
                      }
                      if (onSubmit) onSubmit(newHash);
                    }}
                  />
                </Row>
              </FilterWrapper>
            </PipeProvider>
          );
        })()}
        {(() => {
          if (
            !Search
            || !Search.data
            || !Search.data.brands
            || !Search.data.brands.length
          ) return null;
          return (
            <FilterWrapper title="Marcas">
              <MultipleOptionsFilter
                categories={Search.data.brands.map(({ id, name }) => ({ label: name, value: parseInt(`${id}`) }))}
                maxItemsToShow={5}
                value={brands.map(i => ({ value: i }))}
                onChange={(newBrand, add) => {
                  let newBrands = [...brands];
                  if (add) {
                    newBrands.push(newBrand);
                  } else {
                    newBrands = newBrands.filter((e) => e !== newBrand);
                  }

                  setBrands(newBrands);
                  let newHash;
                  const filterObj = {};
                  let filterParamsHash = filterParams || 'e30=';
                  if (!newBrands.length) {
                    filterParamsHash = RemoveIndexInSearchHash(filterParamsHash, ['brands']);
                  } else {
                    filterObj.brands = newBrands.join(',');
                  }

                  if (filterParamsHash) {
                    newHash = AddIndexInSearchHash(filterParamsHash, filterObj);
                  } else {
                    newHash = AddIndexInSearchHash('e30=', filterObj);
                  }

                  if (newHash === 'e30=') {
                    onSubmit(false);
                    return;
                  }
                  if (onSubmit) onSubmit(newHash);
                }}
              />
            </FilterWrapper>
          );
        })()}
        {(() => {
          if (
            !Search
            || !Search.data
            || !Search.data.features
            || !Search.data.features.length
          ) return null;
          const featuresOptions = {};
          Search.data.features.forEach(({ name, value }) => {
            if (!featuresOptions[name]) featuresOptions[name] = [];
            featuresOptions[name].push({
              label: value,
              value,
            });
          });
          return Object.keys(featuresOptions).map((k) => {
            return (
              <FilterWrapper key={k} title={k}>
                <MultipleOptionsFilter
                  value={features}
                  maxItemsToShow={5}
                  categories={featuresOptions[k].map(({ label, value }) => ({ label, value }))}
                  onChange={(newBrand, add) => {
                    let newFeature = [...features];
                    if (add) {
                      newFeature.push({
                        type: k,
                        value: newBrand,
                      });
                    } else {
                      newFeature = newFeature.filter(({ value }) => value !== newBrand);
                    }

                    let newHash;
                    const filterObj = {};
                    let filterParamsHash = filterParams || 'e30=';
                    /* eslint-disable */
                      filterParamsHash = RemoveIndexInSearchHash(
                        filterParamsHash,
                        [
                          ...features.map((_, ind) => `Features[${ind}].Type`),
                          ...features.map((_, ind) => `Features[${ind}].Value`),
                        ],
                      );
                    /* eslint-enable */
                    if (newFeature.length) {
                      newFeature.forEach(({ type, value }, ind) => {
                        filterObj[`Features[${ind}].Type`] = type;
                        filterObj[`Features[${ind}].Value`] = value;
                      });
                    }

                    setFeatures(newFeature);
                    if (filterParamsHash) {
                      newHash = AddIndexInSearchHash(filterParamsHash, filterObj);
                    } else {
                      newHash = AddIndexInSearchHash('e30=', filterObj);
                    }

                    if (newHash === 'e30=') {
                      onSubmit(false);
                      return;
                    }
                    if (onSubmit) onSubmit(newHash);
                  }}
                />
              </FilterWrapper>
            );
          });
        })()}
        {/* <FilterWrapper className="vert-box-filter-rating" title="Avaliação"> */}
        {/*   <OptionsFilter categories={categoryFilterRating} maxItemsToShow="5" /> */}
        {/* </FilterWrapper> */}
      </div>
    </Col>
  );
};
SearchFilter.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.object,
  filterParams: PropTypes.string,
  onSubmit: PropTypes.func,
  clearFilters: PropTypes.func,
  hideStores: PropTypes.bool,
};

export default SearchFilter;
